module.exports = __webpack_public_path__ + "static/media/views-on-cybersecurity-cover-de.47750ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ebook/views-on-cybersecurity-cover-de.png
// module id = 558
// module chunks = 0